function submitForm() {
  if ($('.upload-form').length) {
    $('.upload-form')
      .submit(function (e) {
        e.preventDefault();
        $.ajax({
          url: $(this).attr('action'),
          type: 'POST',
          data: new FormData(this),
          processData: false,
          contentType: false
        });
      });
  }
}

function resetAmount(e) {
  e.preventDefault();
  $('.amount').each(function (i) {
    $(this).val(0)
  })
}

function setDefaultAmount() {
  $('.amount').click(function (e) {
    if ($(this).val() == 0) {
      $(this).val($(this).data('amount'));
    }
  })
}

function uploadPayroll() {
  if ($('.upload-payroll').length) {
    $('.upload-payroll').change(function () {
      $(this).closest('form').submit();
    })
  }
}

function niceInputFile() {
  if ($('.id-input-file').length) {
    $('.id-input-file').ace_file_input({
      no_file: 'Brak wybranych plików',
      btn_choose: 'wybierz',
      btn_change: 'zmień',
      droppable: false,
      thumbnail: false //| true | large
      //whitelist: ['csv']
    });
  }
}

function setDisabled() {
  if ($('.set_disabled').length) {
    $('.set_disabled').click(function () {
      var e = $(this);
      e.addClass('disabled');
      setTimeout("e.removeClass('disabled');", 5000);
    });
  }
}

//function setFlagForPicture() {
//  if ($('.set-flag').length) {
//    $('.set-flag').click(function(e){
//      e.preventDefault();
//      uri =
//      $.ajax({
//        url:
//      })
//    })
//  }
//}

function convertCordinates(elem) {
  elem.keyup(function () {
    $(this).val($(this).val().replace(/[,\s]/, '.'));
  });
}

function autoComplete() {
  if ($('.autocmp').length) {
    $('.autocmp').autocomplete({
      serviceUrl: '/admin/calculator/products/',
      dataType: 'json',
      minChars: 4,
      onSelect: function (suggestion) {
        $('#' + $(this).data('product_id')).val(suggestion.data)
      }
    });
  }
}

function toggleMenu() {
  $('#menu-toggler').click(function () {
    var el = $('#sidebar');
    if ($(this).hasClass('display') && !el.hasClass('display')) {
      el.addClass('display');
    } else if (!$(this).hasClass('display') && el.hasClass('display')) {
      el.removeClass('display');
    }
  })
}

function plusMinusInput() {
  // Namespacowane eventy (.pm) pozwalają na off() przed ponownym on() -
  // chroni przed duplikatami handlerów przy wielokrotnym wywołaniu loadOnLoad().
  $('.btn-number').off('click.pm').on('click.pm', function (e) {
    e.preventDefault();

    var fieldName = $(this).attr('data-field');
    var type = $(this).attr('data-type');
    var input = $("input[name='" + fieldName + "']");
    var currentVal = parseInt(input.val());
    if (!isNaN(currentVal)) {
      if (type == 'minus') {

        if (currentVal > input.attr('min')) {
          input.val(currentVal - 1).change();
        }
        if (parseInt(input.val()) == input.attr('min')) {
          $(this).attr('disabled', true);
        }

      } else if (type == 'plus') {

        if (currentVal < input.attr('max')) {
          input.val(currentVal + 1).change();
        }
        if (parseInt(input.val()) == input.attr('max')) {
          $(this).attr('disabled', true);
        }

      }
    } else {
      input.val(0);
    }
  });
  $('.input-number').off('focusin.pm').on('focusin.pm', function () {
    $(this).data('oldValue', $(this).val());
  });
  $('.input-number, input[type=number]').off('click.pm').on('click.pm', function () {
    $(this).select();
  });
  $('.input-number').off('change.pm').on('change.pm', function () {

    var minValue = parseInt($(this).attr('min'));
    var maxValue = parseInt($(this).attr('max'));
    var valueCurrent = parseInt($(this).val());

    var name = $(this).attr('name');
    if (valueCurrent >= minValue) {
      $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
    } else {
      alert('Sorry, the minimum value was reached');
      $(this).val($(this).data('oldValue'));
    }
    if (valueCurrent <= maxValue) {
      $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
    } else {
      alert('Sorry, the maximum value was reached');
      $(this).val($(this).data('oldValue'));
    }

    var productId = $(this).data('product');
    var $input = $(this);
    clearTimeout($input.data('saveTimer'));
    $input.data('saveTimer', setTimeout(function () {
      updateTotalQuantity(productId, $input.val());
    }, 600));
  });

  $(".input-number").off('keydown.pm').on('keydown.pm', function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode == 65 && e.ctrlKey === true) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  });
}

function updateTotalQuantity(product_id, quantity) {
  var csrfToken = $('meta[name="csrf-token"]').attr('content');
  var $row = $('#row-' + product_id);
  $row.addClass('table-warning');
  $.ajax({
    url: '/admin/products/' + product_id + '/update_total_quantity',
    type: 'PUT',
    data: { total_quantity: quantity },
    beforeSend: function (xhr) {
      xhr.setRequestHeader('X-CSRF-Token', csrfToken);
    },
    success: function () {
      $row.removeClass('table-warning').addClass('table-success');
      setTimeout(function () { $row.removeClass('table-success'); }, 1500);
    },
    error: function () {
      $row.removeClass('table-warning').addClass('table-danger');
    }
  });
}

function handleAvailability() {
  $('#menu-meals').off('change', '.availability').on('change', '.availability', function () {
    updateMealRequest($(this).data('meal'), 'is_available', $(this).prop('checked'))
  })
}

function handleDivision() {
  $('#menu-meals').off('change', '.division-select').on('change', '.division-select', function () {
    updateMealRequest($(this).data('meal'), 'division_id', $(this).val())
  })
}

function updateMealRequest(meal_id, field_name, value) {
  var csrfToken = $('meta[name="csrf-token"]').attr('content');
  $.ajax({
    url: '/admin/meals/' + meal_id,
    type: 'PUT',
    data: "meal[" + field_name + "]=" + value,
    beforeSend: function (xhr) {
      xhr.setRequestHeader("X-CSRF-Token", csrfToken);
    },
    success: function (data) {
      console.log(data);
    }
  });
}

function handleCateringMeals(table) {
  $('#chosen-meals').on('change', '.meal-checkbox', function () {
    var tr1 = $(this).closest('tr');
    table.row.add(tr1).draw();
    // id = '#catering-meals #meal_'+ $(this).attr('id');
    // $(id).prop('checked', false);
  });

  $('#catering-meals').on('change', '.meal-checkbox', function () {
    var tr = $(this).parents('tr');
    $('#chosen-meals').append(tr.clone());
    table.row(tr).remove().draw();
    $('#chosen-meals').find('#alert').remove()

    // if ($(this).prop('checked')) {
    //   list.push({
    //     meal: $(this).data('meal'),
    //     kcal: $(this).data('kcal'),
    //     category: $(this).data('category')
    //   })
    // } else {
    //   // var index = array.indexOf(item);
    //   // if (index !== -1) array.splice(index, 1);
    // }
    // console.log(list);
    // list.forEach(function(o) {
    //   str = '<li>' + o.meal + '</li>';
    // })
    // $('#chosen-meals').append(str)
  });
}

function handleCateringTypes() {
  var csrf_token = $('meta[name="csrf-token"]').attr('content');
  $('#chosen-meals, #catering-meals').on('change', '.meal-type', function () {
    var meal_id = $(this).data('id')
    $.ajax({
      url: '/admin/meals/' + meal_id,
      type: 'PUT',
      data: "meal[thermal]=" + $(this).is(':checked'),
      beforeSend: function (xhr) {
        xhr.setRequestHeader("X-CSRF-Token", csrf_token);
      },
      success: function (data) {
        console.log(data);
      }
    })
  })
}



// Buduje konfigurację flatpickr z aktualnym locale (lazy - locale musi być załadowane)
function buildFlatpickrOptions() {
  return {
    dateFormat: "Y-m-d",
    locale: (typeof flatpickr !== 'undefined' && flatpickr.l10ns && flatpickr.l10ns.pl)
              ? flatpickr.l10ns.pl
              : 'default',
    allowInput: true,
    disableMobile: true
  };
}

function buildFlatpickrOptionsFor(el) {
  var opts = buildFlatpickrOptions();
  var d = el.dataset;
  if (d.enabletime)      opts.enableTime      = true;
  if (d.time_24hr)       opts.time_24hr       = true;
  if (d.nocalendar)      opts.noCalendar      = true;
  if (d.dateformat)      opts.dateFormat       = d.dateformat;
  if (d.minDate)         opts.minDate          = d.minDate;
  if (d.maxDate)         opts.maxDate          = d.maxDate;
  if (d.mintime)         opts.minTime          = d.mintime;
  if (d.maxtime)         opts.maxTime          = d.maxtime;
  if (d.minuteincrement) opts.minuteIncrement  = parseInt(d.minuteincrement, 10);
  if (d.defaulthour)     opts.defaultHour      = parseInt(d.defaulthour, 10);
  if (d.defaultminute)   opts.defaultMinute    = parseInt(d.defaultminute, 10);
  if (d.mode)            opts.mode             = d.mode;
  return opts;
}

// ---------------------------------------------------------------------------
// Wyszukiwarka w bocznym menu - filtruje linki na bieżąco przy wpisywaniu.
// Otwiera podgrupy zawierające pasujące elementy i ukrywa niepasujące.
// ---------------------------------------------------------------------------
function sidebarMenuSearch() {
  var input  = document.getElementById('sidebar-search-input');
  var clearBtn = document.getElementById('sidebar-search-clear');
  if (!input) return;

  function getNavText(link) {
    if (!link) return '';
    // Pobierz tekst bez zawartości badge'ów i ikon
    var clone = link.cloneNode(true);
    clone.querySelectorAll('.badge, i, .nav-arrow').forEach(function (el) { el.remove(); });
    return clone.textContent.toLowerCase().trim();
  }

  function filterMenu(query) {
    var q = query.toLowerCase().trim();
    var topItems = document.querySelectorAll('#navigation > .nav-item');

    topItems.forEach(function (mainItem) {
      var submenu  = mainItem.querySelector(':scope > ul');
      var mainLink = mainItem.querySelector(':scope > .nav-link');

      if (submenu) {
        var subItems = submenu.querySelectorAll(':scope > .nav-item');
        var anyMatch = false;

        subItems.forEach(function (subItem) {
          var link    = subItem.querySelector('.nav-link');
          var matches = !q || getNavText(link).includes(q);
          subItem.style.display = matches ? '' : 'none';
          if (matches) anyMatch = true;
        });

        if (!q) {
          // Przywróć naturalny stan - usuń atrybut wymuszony przez wyszukiwanie
          mainItem.style.display = '';
          if (submenu.dataset.searchExpanded === 'true') {
            submenu.classList.remove('show');
            delete submenu.dataset.searchExpanded;
          }
        } else if (anyMatch) {
          mainItem.style.display = '';
          if (!submenu.classList.contains('show')) {
            submenu.classList.add('show');
            submenu.dataset.searchExpanded = 'true';
          }
        } else {
          mainItem.style.display = 'none';
        }
      } else {
        // Element bez podmenu (np. Pulpit)
        var matches = !q || getNavText(mainLink).includes(q);
        mainItem.style.display = matches ? '' : 'none';
      }
    });
  }

  input.addEventListener('input', function () {
    var q = this.value;
    filterMenu(q);
    if (clearBtn) {
      clearBtn.classList.toggle('d-none', q.length === 0);
    }
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      filterMenu('');
      clearBtn.classList.add('d-none');
      input.focus();
    });
  }
}

function loadOnLoad() {
  // $('.formtastic').valtastic();
  // $('.summernote').summernote();
  plusMinusInput();
  handleAvailability();
  handleDivision();
  //niceInputFile();
  //submitForm();
  //uploadPayroll();
  //setDisabled();
  if ($('.amount').length) {
    setDefaultAmount();
  }
  if ($('#longitude').length) {
    convertCordinates($('#longitude'));
    convertCordinates($('#latitude'));
  }

  // flatpickr - inicjalizacja inputów .datepicker
  if (typeof flatpickr !== 'undefined') {
    document.querySelectorAll('.datepicker').forEach(function (el) {
      if (!el._flatpickr) flatpickr(el, buildFlatpickrOptionsFor(el));
    });
  }

  $('#reset_amount').click(function (event) {
    resetAmount(event)
  });
  autoComplete();
  toggleMenu();
  sidebarMenuSearch();
}

$(function () {
  loadOnLoad();
});

// Po AJAX-owym załadowaniu panelu bocznego - inicjalizuj datepickery na nowych elementach
document.addEventListener('ajax-panel:loaded', function () {
  if (typeof flatpickr !== 'undefined') {
    document.querySelectorAll('.datepicker').forEach(function (el) {
      if (!el._flatpickr) flatpickr(el, buildFlatpickrOptionsFor(el));
    });
  }
});

// -----------------------------------------------------------------------
// Generyczny boczny panel (Offcanvas) - jeden panel dla całej aplikacji.
//
// Konfiguracja przez data-* atrybuty na linku wyzwalającym:
//   data-panel              - marker wyzwalający (wymagany)
//   data-panel-title        - tytuł w nagłówku
//   data-panel-icon         - klasa FA bez 'fa-solid', np. 'fa-pen-to-square'
//   data-panel-full-link    - URL przycisku "Pełna edycja" (opcjonalny)
//   data-panel-width        - szerokość CSS, np. '700px' (opcjonalny)
//   data-panel-push-state   - 'true': zmień URL paska adresu na czas otwarcia
//   data-panel-dirty        - 'true': śledź niezapisane zmiany
// -----------------------------------------------------------------------
(function () {
  var PANEL_ID       = 'ajax-side-panel';
  var DIRTY_BADGE_ID = 'ajax-side-panel-dirty-badge';

  function el(id) { return document.getElementById(id); }

  function markPanelDirty(panelEl) {
    var instance = bootstrap.Offcanvas.getInstance(panelEl);
    if (instance) instance._config.backdrop = 'static';

    if (!el(DIRTY_BADGE_ID)) {
      var titleText = panelEl.querySelector('.panel-title-text');
      if (titleText) {
        var badge = document.createElement('span');
        badge.id = DIRTY_BADGE_ID;
        badge.className = 'badge bg-warning text-dark ms-2 fw-normal';
        badge.style.fontSize = '0.7rem';
        badge.textContent = 'niezapisane zmiany';
        titleText.insertAdjacentElement('afterend', badge);
      }
    }
  }

  function markPanelClean(panelEl) {
    var instance = bootstrap.Offcanvas.getInstance(panelEl);
    if (instance) instance._config.backdrop = true;

    var badge = el(DIRTY_BADGE_ID);
    if (badge) badge.remove();
  }

  // Eksport globalny - używany z *.js.haml po zapisaniu formularza
  window.markPanelClean = markPanelClean;

  function configurePanel(panelEl, opts) {
    var iconEl = panelEl.querySelector('.panel-icon');
    if (iconEl) iconEl.className = 'panel-icon fa-solid me-2 text-muted ' + (opts.icon || 'fa-pen-to-square');

    var titleEl = panelEl.querySelector('.panel-title-text');
    if (titleEl) titleEl.textContent = opts.title || '';

    var fullLinkEl = el(PANEL_ID + '-full-link');
    if (fullLinkEl) {
      if (opts.fullLink) {
        fullLinkEl.href = opts.fullLink;
        fullLinkEl.style.display = '';
      } else {
        fullLinkEl.style.display = 'none';
      }
    }

    panelEl.style.width = opts.width || '';
  }

  function loadPanel(url, opts) {
    opts = opts || {};
    var panelEl = el(PANEL_ID);
    var body    = el(PANEL_ID + '-body');
    if (!panelEl || !body) return;

    configurePanel(panelEl, opts);
    markPanelClean(panelEl);

    if (opts.pushState && window.location.href !== url) {
      history.pushState({ ajaxPanel: true, previousUrl: window.location.href }, '', url);
    }

    body.innerHTML = '<div class="text-center py-5"><span class="spinner-border text-secondary" role="status"></span></div>';
    bootstrap.Offcanvas.getOrCreateInstance(panelEl).show();

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        // Podmiana innerHTML - Alpine v3 MutationObserver obsługuje cleanup i init automatycznie.
        // NIE wywołujemy destroyTree - podwójny cleanup kasuje _x_lookup → Object.values(undefined).
        body.innerHTML = html;

        // Uruchom ponownie inline <script> (m.in. OrderCalculatorApp, initDietSelect)
        body.querySelectorAll('script').forEach(function (oldScript) {
          var newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach(function (attr) { newScript.setAttribute(attr.name, attr.value); });
          newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });

        // Zdarzenie informujące formularze o załadowaniu panelu
        document.dispatchEvent(new CustomEvent('ajax-panel:loaded', { detail: { url: url } }));

        var form = body.querySelector('form');
        if (form) {
          // Obsługa submitu przez fetch+FormData zamiast data-remote="true".
          // stopPropagation blokuje Rails UJS (delegowany na document) przed
          // podwójnym wysłaniem - UJS nie sprawdza defaultPrevented.
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var csrfToken = document.querySelector('meta[name="csrf-token"]');
            var fd = new FormData(this);
            fetch(this.action, {
              method: this.getAttribute('method') || 'post',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept':           'text/javascript',
                'X-CSRF-Token':     csrfToken ? csrfToken.content : ''
              },
              body: fd
            })
              .then(function (r) { return r.text(); })
              .then(function (js) {
                // Wykonaj odpowiedź JS przez tag <script> - tak jak robi to rails-ujs.
                // Unikamy eval() (wymaga unsafe-eval w CSP); <script> potrzebuje tylko unsafe-inline.
                var scriptEl = document.createElement('script');
                scriptEl.textContent = js;
                document.head.appendChild(scriptEl);
                scriptEl.remove();
              })
              .catch(function () {
                var panelBody = el(PANEL_ID + '-body');
                if (panelBody) {
                  panelBody.insertAdjacentHTML('afterbegin',
                    '<div class="alert alert-danger m-3">Błąd zapisu - spróbuj ponownie.</div>');
                }
              });
          });

          if (opts.dirty) {
            form.addEventListener('input',  function () { markPanelDirty(panelEl); });
            form.addEventListener('change', function () { markPanelDirty(panelEl); });
          }

          var cancelBtn = body.querySelector('a.btn-outline-secondary');
          if (cancelBtn) {
            cancelBtn.addEventListener('click', function (e) {
              e.preventDefault();
              markPanelClean(panelEl);
              bootstrap.Offcanvas.getInstance(el(PANEL_ID))?.hide();
            });
          }
        }
      })
      .catch(function () {
        body.innerHTML = '<div class="alert alert-danger m-3">Błąd ładowania formularza.</div>';
      });
  }

  // Eksport globalny - używany przez auto-open-panel i *.js.haml
  window.loadAjaxPanel = loadPanel;

  // Delegowany klik na [data-panel]
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-panel]');
    if (!link) return;
    e.preventDefault();
    loadPanel(link.href, {
      title:     link.dataset.panelTitle    || '',
      icon:      link.dataset.panelIcon     || 'fa-pen-to-square',
      fullLink:  link.dataset.panelFullLink || null,
      width:     link.dataset.panelWidth    || '',
      pushState: link.dataset.panelPushState === 'true',
      dirty:     link.dataset.panelDirty    === 'true'
    });
  });

  // Po zamknięciu - przywróć URL, wyczyść panel, ukryj przycisk pełnej edycji
  document.addEventListener('hidden.bs.offcanvas', function (e) {
    if (e.target.id !== PANEL_ID) return;

    markPanelClean(e.target);
    e.target.style.width = '';

    var state = history.state;
    if (state && state.ajaxPanel && state.previousUrl) {
      history.replaceState({}, '', state.previousUrl);
    }

    var body = el(PANEL_ID + '-body');
    if (body) body.innerHTML = '<div class="text-center py-5"><span class="spinner-border text-secondary" role="status"></span></div>';

    var fullLinkEl = el(PANEL_ID + '-full-link');
    if (fullLinkEl) fullLinkEl.style.display = 'none';
  });

  // Auto-otwarcie gdy kontroler przekierował z URL edycji (flash[:open_panel])
  document.addEventListener('DOMContentLoaded', function () {
    var meta = document.querySelector('meta[name="auto-open-panel"]');
    if (!meta) return;
    loadPanel(meta.getAttribute('content'), {
      title: 'Edycja zamówienia', icon: 'fa-pen-to-square', pushState: false, dirty: true
    });
    meta.remove();
  });
}());

// ---------------------------------------------------------------------------
// Eksport globalny funkcji z custom.js – wywoływane z inline <script> w widokach.
// W Vite ESM każda funkcja jest module-scoped; bez window.X inline skrypty ich nie widzą.
window.loadOnLoad         = loadOnLoad;
window.handleCateringMeals = handleCateringMeals;
window.handleCateringTypes = handleCateringTypes;
window.handleAvailability  = handleAvailability;
window.handleDivision      = handleDivision;
window.autoComplete        = autoComplete;
window.plusMinusInput      = plusMinusInput;
window.convertCordinates   = convertCordinates;
window.resetAmount         = resetAmount;
window.toggleMenu          = toggleMenu;
window.sidebarMenuSearch   = sidebarMenuSearch;

// ---------------------------------------------------------------------------
// Alpine.js - komponent szybkiej edycji wiersza posiłku (cena + dostępność).
// Używany w admin/marketplace/vendor_meals/_meal_row.html.haml
// ---------------------------------------------------------------------------
window.mealQuickEdit = function (url, initGrossPrice, initAvailable, initMarketplaceVisible, initQuantity) {
  return {
    price:     initGrossPrice,
    available: initAvailable,
    marketplaceVisible: initMarketplaceVisible !== undefined ? initMarketplaceVisible : true,
    quantity:  initQuantity !== undefined ? initQuantity : -1,
    saving:    false,
    saved:     false,
    error:     false,

    get quantityDisplay() {
      return this.quantity === -1 ? '∞' : this.quantity;
    },

    async patch(data) {
      this.saving = true;
      this.saved  = false;
      this.error  = false;
      const token = document.querySelector('meta[name="csrf-token"]')?.content || '';
      try {
        const resp = await fetch(url, {
          method:  'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': token,
            'Accept':       'application/json'
          },
          body: JSON.stringify({ meal: data })
        });
        if (resp.ok) {
          const json = await resp.json();
          if ('gross_price'  in json) this.price     = parseFloat(json.gross_price);
          if ('is_available' in json) this.available = json.is_available;
          if ('marketplace_visible' in json) this.marketplaceVisible = json.marketplace_visible;
          if ('quantity'     in json) this.quantity  = json.quantity;
          this.saved = true;
          setTimeout(() => { this.saved = false; }, 1500);
        } else {
          this.error = true;
          setTimeout(() => { this.error = false; }, 3000);
        }
      } catch (_e) {
        this.error = true;
        setTimeout(() => { this.error = false; }, 3000);
      } finally {
        this.saving = false;
      }
    },

    savePrice() {
      const v = parseFloat(String(this.price).replace(',', '.'));
      if (!isNaN(v) && v >= 0) this.patch({ gross_price: v.toFixed(2) });
    },

    saveQuantity() {
      const raw = String(this.quantity).trim();
      if (raw === '∞' || raw === '' || raw === '-1') {
        this.quantity = -1;
        this.patch({ quantity: -1 });
      } else {
        const v = parseInt(raw);
        if (!isNaN(v) && v >= 0) this.patch({ quantity: v });
      }
    },

    saveAvailable() {
      this.patch({ is_available: this.available });
    },

    saveMarketplace() {
      this.patch({ marketplace_visible: this.marketplaceVisible });
    }
  };
};

// ---------------------------------------------------------------------------
// Funkcje globalne – wcześniej w application.js (Sprockets manifest, nieimportowany przez Vite).
// Eksponowane na window, bo są wywoływane z inline <script> w widokach i Alpine.js komponentach.
// ---------------------------------------------------------------------------

// Zlicza dni robocze między datami, pomijając wykluczone daty.
// Używa UTC aby uniknąć błędów przy przejściu DST (marzec/październik).
window.countDays = function(startDate, endDate, weekdays, inactiveDays) {
  var count = 0;
  var endDateObj = new Date(endDate);
  var currentDate = new Date(startDate);
  if (isNaN(currentDate.getTime()) || isNaN(endDateObj.getTime())) return 0;
  var inactiveDates = Array.isArray(inactiveDays)
    ? inactiveDays.map(function(day) { return new Date(day).toISOString().slice(0, 10); })
    : [];
  while (currentDate.toISOString().slice(0, 10) <= endDateObj.toISOString().slice(0, 10)) {
    if (weekdays.includes(currentDate.getUTCDay()) && !inactiveDates.includes(currentDate.toISOString().slice(0, 10))) {
      count++;
    }
    currentDate.setUTCDate(currentDate.getUTCDate() + 1);
  }
  return count;
};

// Wyświetla czas pracy od startDate w elemencie #time-elapsed.
// Używana w worksheet/index przez setInterval.
window.upTime = function(startDate) {
  if (!startDate) return false;
  var diff = Math.round((new Date().getTime() - new Date(startDate).getTime()) / 1000);
  var h = Math.floor(diff / 3600);
  diff -= h * 3600;
  var m = Math.floor(diff / 60);
  var s = diff - m * 60;
  var el = document.getElementById('time-elapsed');
  if (el) el.innerHTML = h + ' godz., ' + m + ' min, ' + s + ' sek';
};

/*
 * Notatki SQL - wkleić w konsoli bazy (nie usuwać):
 *
 * delete from menus where prepared_at between '2026-03-02' and '2026-03-08';
 * select prepared_at + interval '133 days' from menus where prepared_at between '2025-10-20' and '2025-10-26';
 *
 * insert into menus (diet_id, meal_id, meal_kind, prepared_at, created_at, updated_at) Select diet_id, meal_id, meal_kind, '2026-03-02' as prepared_at, NOW(), NOW() from menus where prepared_at='2025-10-20';
 * insert into menus (diet_id, meal_id, meal_kind, prepared_at, created_at, updated_at) Select diet_id, meal_id, meal_kind, '2026-03-03' as prepared_at, NOW(), NOW() from menus where prepared_at='2025-10-21';
 * insert into menus (diet_id, meal_id, meal_kind, prepared_at, created_at, updated_at) Select diet_id, meal_id, meal_kind, '2026-03-04' as prepared_at, NOW(), NOW() from menus where prepared_at='2025-10-22';
 * insert into menus (diet_id, meal_id, meal_kind, prepared_at, created_at, updated_at) Select diet_id, meal_id, meal_kind, '2026-03-05' as prepared_at, NOW(), NOW() from menus where prepared_at='2025-10-23';
 * insert into menus (diet_id, meal_id, meal_kind, prepared_at, created_at, updated_at) Select diet_id, meal_id, meal_kind, '2026-03-06' as prepared_at, NOW(), NOW() from menus where prepared_at='2025-10-24';
 * insert into menus (diet_id, meal_id, meal_kind, prepared_at, created_at, updated_at) Select diet_id, meal_id, meal_kind, '2026-03-07' as prepared_at, NOW(), NOW() from menus where prepared_at='2025-10-25';
 * insert into menus (diet_id, meal_id, meal_kind, prepared_at, created_at, updated_at) Select diet_id, meal_id, meal_kind, '2026-03-08' as prepared_at, NOW(), NOW() from menus where prepared_at='2025-10-26';
 */
